import { render, staticRenderFns } from "./EditionOpener.vue?vue&type=template&id=aa3bd742&scoped=true&"
import script from "./EditionOpener.vue?vue&type=script&lang=js&"
export * from "./EditionOpener.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3bd742",
  null
  
)

export default component.exports